import { tableEntryStyle } from "../../components/TableComponent";
import { HStack } from "../../components/utils";
import {
  formatCurrencyRoboto,
  formatToReadableNumber,
} from "../../utils/currencyRoboto";
import { formatDisplayDate } from "../../utils/date";
import { getSecurityColor } from "../../utils/historicUtilities";

export function NumberOfSharesRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-2">
      <p className={tableEntryStyle}>
        {formatToReadableNumber({
          value: data.data?.sourceNoOfShares,
          format: data.data.currencyType,
        })}
      </p>
    </div>
  );
}
export function ConversionDateRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-3">
      {data.data.conversionDate ? (
        <p className={tableEntryStyle}>{formatDisplayDate(data.data.conversionDate)}</p>
      ) : (
        <p className={tableEntryStyle}>-</p>
      )}
    </div>
  );
}

export function SecurityTypeRender(data: any) {
  const isConversionSecurity = data.colDef?.field === "conversionSecurityId";
  const subType = isConversionSecurity
    ? data.data?.conversionSecuritySubType
    : data.data?.sourceInstrumentSubType;

  return (
    <div className="whitespace-nowrap py-2">
      <p className={tableEntryStyle}>{data.value}</p>
      {subType && (
        <p
          className={`${getSecurityColor(
            subType
          )} text-xs text-center w-fit px-2 py-0.5 font-semibold rounded-md mt-1`}
        >
          {subType}
        </p>
      )}
    </div>
  );
}
